var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-home",staticStyle:{"padding":"0px 20px"},attrs:{"id":"app-home"}},[_vm._v(" 加载中 ... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }